import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'CFN Kimya',
  logo: { name: 'CFN Kimya', src: '/logo/cfnkimya.webp' },
  portrait: { src: '/photo/portrait-fatma-koktas.png', alt: 'Fatma Köktaş' },
  quote: [
    'Digital transformation and sustainability are two major business imperatives of modern '
    + 'business world. In that respect, assessing where we are and where we would like to be '
    + 'and having an aligned understanding and commitment among our management team is very '
    + 'precious. We chose Digitopia because of their professionalism and sound methodology '
    + 'in maturity models of both digital and sustainability transformation.',
  ],
  attribution: 'Fatma Köktaş, Board Member and CEO',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 15
